module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAF96VFh0UmF3IHByb2ZpbGUgdHlwZSBBUFAxAAAImeNKT81LLcpMVigoyk/LzEnlUgADYxMuE0sTS6NEAwMDCwMIMDQwMDYEkkZAtjlUKNEABZiYm6UBoblZspkpiM8FAE+6FWgbLdiMAAAAsElEQVQ4je1TsQ3CQBCzX9TJQ0XNCExCgUSgQtmAMAN1FoBQpmEApmAEilQUQZxQao4CJYoAIT6hxNXJln2+4uhvZ3PqLVaFhQNIiIIRvfXkTLLnYq6HGBh0nwUJU0iYYuD1Pwaowhoq2WR7CdPGDAD0N4ECj9ousMn0Nw065TDcLSryMI4BAKP9ClmRfxdwvJ5exKzI3/J1tD7hHwDQJsHF9RMrMyFGiSUJaWJWMLoDAvgxHLVLn9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreadsheet-icon.png
// module id = 2545
// module chunks = 17